// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".News__container___2PLde{margin:80px 24px}.News__title___1xPOW{color:inherit;font-weight:500;font-size:40px;line-height:56px;font-weight:200}.News__grid___9GAVM{max-width:780px;margin:24px auto 0}@media (min-width:1280px){.News__grid___9GAVM{display:flex;grid-gap:40px;gap:40px;max-width:none;margin:24px 0 0}}.News__big___30WEV{flex-basis:70%}@media (min-width:1280px){.News__big___30WEV{max-width:620px}}.News__right___NIOTV{display:none;margin-top:40px}@media (min-width:720px){.News__right___NIOTV{display:flex;flex-direction:column;grid-gap:32px;gap:32px}}@media (min-width:1280px){.News__right___NIOTV{margin-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "News__container___2PLde",
	"title": "News__title___1xPOW",
	"grid": "News__grid___9GAVM",
	"big": "News__big___30WEV",
	"right": "News__right___NIOTV"
};
module.exports = ___CSS_LOADER_EXPORT___;
